import React  from 'react';
import MembershipMemberMappingBasicInfoComponent from './membership-member-mapping-basic-info.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';

export const MembershipMemberMappingComponent = ({ membershipType, users, membership, handleInnerFormChange, selectedMembershipMemberMappings,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Membership Member Mapping Information',
        component:  <MembershipMemberMappingBasicInfoComponent
        users={users} 
        membershipType={membershipType} 
        membership={membership}
        handleInnerFormChange={handleInnerFormChange} 
        selectedMembershipMemberMappings={selectedMembershipMemberMappings}
    />,
    isVisible:true,
    }
    
  ]
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
    <TabContainer tabItems={tabItems} />
 
    <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
           <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}
          
            type="submit"
        >
          Save
        </button>
      </div>
     </div>
  )
}
export default MembershipMemberMappingComponent;
